import {ErrorObject} from "ajv";
import draft7MetaSchema from "ajv/dist/refs/json-schema-draft-07.json";
import addFormats from "ajv-formats";
//import mapper_en from "ajv-i18n/localize/en";
import mapper_en from "./ajv/i18n/en";
import i18next from "i18next";
import {omit} from "ramda";

import {NfAjv2019} from "./ajv/nf-ajv";


let mapper = mapper_en;

function setLanguage(lang: string) {
    //import(`ajv-i18n/localize/${lang}/index`)
    import(`./ajv/i18n/${lang}`)
        .then(s => {
            if (typeof s?.default === "function") {
                mapper = s.default;
            }
        })
        .catch(() => {
            const idx = lang.indexOf("-");
            if (idx > 0) {
                setLanguage(lang.substring(0, idx));
            }
        });
}

if (i18next.language) {
    setLanguage(i18next.language);
}

i18next.on("languageChanged", lang => {
    setLanguage(lang);
});

export interface SchemaValidationSuccess {
    type: "success";
}

export const ajv = new NfAjv2019({
    allErrors: true,
    addUsedSchema: false,
    allowUnionTypes: true,
    strict: "log",
});
ajv.addMetaSchema(omit(["default"], draft7MetaSchema));
addFormats(ajv);
ajv.addFormat("markdown", () => true);
ajv.addFormat("nf-expression", () => true);
// NJsonSchema non-standard formats
ajv.addFormat("time-span", () => true);
ajv.addFormat("guid", () => true);
ajv.addFormat("int32", () => true);
ajv.addFormat("int64", () => true);
ajv.addFormat("float", () => true);
ajv.addFormat("double", () => true);
ajv.addFormat("decimal", () => true);
ajv.addFormat("byte", () => true);
ajv.addFormat("binary", () => true);
ajv.addFormat("phone", () => true);

export interface SchemaValidationFailure {
    type: "failure";
    errors: ErrorObject[];
}

export type SchemaValidationResult = SchemaValidationSuccess | SchemaValidationFailure;

export const isValidationFailure = (result: SchemaValidationResult): result is SchemaValidationFailure => {
    return result.type === "failure";
};

export const validate = (schemaKeyRef: object | boolean, data: any): SchemaValidationResult => {
    const valid = ajv.validate(schemaKeyRef, data);
    if (typeof valid !== "boolean") {
        throw new Error("No $async validation allowed");
    }
    if (!valid) {
        if (ajv.errors && mapper) {
            mapper(ajv.errors);
        }
        return {
            type: "failure",
            errors: ajv.errors ?? [],
        };
    }
    return {type: "success"};
};

export const validateJsonSchema = (schema: object): SchemaValidationResult => {
    const valid = ajv.validateSchema(schema);
    if (valid) {
        //ajv.compile(schema);
        return {type: "success"};
    }
    if (ajv.errors && mapper) {
        mapper(ajv.errors);
    }
    return {
        type: "failure",
        errors: ajv.errors ?? [],
    };
};

export const translateValidationErrors = (errors: ErrorObject[]) => {
    if (mapper) {
        mapper(errors);
    }
    return errors;
};
